import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { credential, logout } from "../Slice/AuthSlice";
import { getSliderUtilityClass } from "@mui/material";

export const AuthApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({
    baseUrl: "http://localhost:5000",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().Auth.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["User"],
  endpoints: (builder) => ({
    register: builder.mutation({
      query: (credentials) => ({
        url: "/public/auth/register",
        method: "POST",
        body: { ...credentials },
      }),
      
    }),
    login: builder.mutation({
      query: (credentials) => ({
        url: "/public/auth/login",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    getClassByAgeAndGender: builder.mutation({
      query:(data)=>({
         url:'/user/portal/user/class-booking',
         method:'POST',
            body:{...data}
      })
    }),
    getSingleByAgeAndGender: builder.query({
      query:(id)=>({
         url:`/user/portal/user/class-booking/details/${id}`,
         method:'GET',
      })
    }),
    // Subscription
    createPayment:builder.mutation({
      query:(credential)=>({
        url:'/user/portal/user/subscription/create',
        method:"POST",
        body:{...credential}
      })
    }),
   renewSubscription :builder.mutation({
      query:(credential)=>({
        url:`/user/portal/user/subscription/renew`,
        method:"PUT",
        body:{...credential}
      })
    }),
    createChildren:builder.mutation({
      query:(credential)=>({
        url:'/user/portal/user/child/create',
        method:'POST',
        body:{...credential}
      })
    }),
    getChildren:builder.query({
      query:(id)=>({
          url:`/user/portal/user/child/single-child/${id}`,
          method:'GET',
      }),
      transformResponse: (response) => {

        return response?.data;
      }
    }),
    changePassword: builder.mutation({
      query: (credentials) => ({
        url: "/public/auth/change-password",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    getUser:builder.query({
      query:(id)=>({
          url:`/user/auth/get-single-user/${id}`,
          method:'GET',
      }),
      transformResponse: (response) => {

        return response;
      }
  }),
    getAllUser:builder.query({
      query:()=>({
        url:"/user/get-all",
        method:'GET',
    }),
      transformResponse: (response) => {
       //console.log(response)
      return response?.data;
    }
    }),
    logout:builder.mutation({
        query:()=>({
          url:'/BDMF/Admin/logout',
          method:'POST',
        }),
        async onQueryStarted(args,{dispatch,queryFulfilled}){
          try {
              const {data} = await queryFulfilled
              console.log(data)
               dispatch(logout())
          } catch (error) {
              console.log(error);
          }
      }
      }),
    getSlotTime:builder.query({
      query:()=>({
        url:'/user/portal/user/party-package/get-all',
        method:'GET'
      })
    }),
    getAddOn:builder.query({
      query:()=>({
        url:'/admin/portal/party/add-on/getAll',
        method:"GET"
      })
    }),
    createBooking: builder.mutation({
      query: (credentials) => ({
        url: "/user/portal/user/party-booking/create",
        method: "POST",
        body: { ...credentials },
      }),
    }),
    }),
});

export const { useLoginMutation, useLogoutMutation, useRegisterMutation,useGetUserQuery,useGetAllUserQuery,useChangePasswordMutation,useGetClassByAgeAndGenderMutation,useGetSingleByAgeAndGenderQuery,useCreatePaymentMutation,useCreateChildrenMutation,useGetChildrenQuery,useGetSlotTimeQuery,useGetAddOnQuery,useCreateBookingMutation,useRenewSubscriptionMutation} =
  AuthApi;
